import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DesyAngularModule } from 'desy-angular';
import { filter } from 'rxjs';

@Component({
  selector: 'app-tabs',
  imports: [DesyAngularModule, CommonModule, RouterModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  standalone: true,
})
export class TabsComponent implements OnInit {
  @Input() items: { title?: string; url?: string; id?: string }[] = [];
  @Input() type: string = '';
  @Input() defaultTab?: string;
  @Output() tabChanged = new EventEmitter<string>();
  activeTab = signal<string>('1');

  constructor(private router: Router) {}

  private syncWithUrl(url: string) {
    const path = url.split('?')[0];

    const segments = path.split('/').filter(Boolean);
    const last = segments[segments.length - 1];

    this.activeTab.set(last);
  }
  selectTab(id: string) {
    this.activeTab.set(id);
    this.tabChanged.emit(id);
  }

  ngOnInit() {
    // Si es un tab que funciona con URLs
    if (this.type === 'tabsWithURL') {
      this.syncWithUrl(this.router.url);
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => this.syncWithUrl(event.urlAfterRedirects));
    }
    // Si es un tab que no funciona con URLs
    if (this.defaultTab) {
      this.activeTab.set(this.defaultTab);
    }
  }
}
